import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Avatar, Divider } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import ArticleIcon from "@mui/icons-material/Article";
import BrandingWatermarkIcon from "@mui/icons-material/BrandingWatermark";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DataSaverOffIcon from "@mui/icons-material/DataSaverOff";

const ServiceList = () => {
  const list = [
    {
      icon: <LanguageIcon sx={{ color: "#33E68C", width: 28, height: 28 }} />,
      title: "Web Development",
      description:
        "We are a team of experienced web developers who are passionate about creating dynamic, high-quality websites that meet the needs of our clients. Our services encompass all aspects of web development, from the design and functionality of a website to the development of custom features. Save time, cost, energy and get the best results when you build with OnDesign.",
    },
    {
      icon: <BookOnlineIcon sx={{ color: "#33E68C", width: 28, height: 28 }} />,
      title: "Mobile App Development",
      description:
        "Our services cover the entire mobile app development process, from the initial concept and design to the final deployment and maintenance of the app. With our expertise in various mobile platforms such as iOS and Android, we are able to deliver custom mobile applications that are tailored to the specific needs of our clients. We build for quality.",
    },
    {
      icon: <ArticleIcon sx={{ color: "#33E68C", width: 28, height: 28 }} />,
      title: "Document Design & Printing",
      description:
        "Our document design services include custom layout and graphic design, ensuring that your printed materials are not only well-designed but also consistent with your brand identity. Our printing services use state-of-the-art printing technology to produce high-quality prints that are both vibrant and long-lasting.",
    },
    {
      icon: (
        <BrandingWatermarkIcon
          sx={{ color: "#33E68C", width: 28, height: 28 }}
        />
      ),
      title: "Brand Development",
      description:
        "We are a team of branding specialists who are passionate about helping businesses establish a strong, recognizable, and effective brand. Our team works closely with clients to understand their goals, values, and target audience, ensuring that the brand we develop truly reflects the unique qualities of their business.",
    },
    {
      icon: <QueryStatsIcon sx={{ color: "#33E68C", width: 28, height: 28 }} />,
      title: "Data Analysis & Survey",
      description:
        "Our services cover all aspects of data analysis and survey research, from design and implementation to data visualization and interpretation. Whether you need help conducting market research, analyzing customer feedback, or gaining insights into your business data, our team has the skills and experience to deliver the information you need.",
    },
    {
      icon: (
        <DataSaverOffIcon sx={{ color: "#33E68C", width: 28, height: 28 }} />
      ),
      title: "Infographics Design",
      description:
        "Our team of graphic designers and data experts are passionate about helping businesses communicate complex information in an engaging and visual way. They are skilled in data visualization and design, ensuring that every infographic we create is both informative and visually appealing. We simplify complex information and make it accessible to a wider audience. ",
    },
  ];

  return (
    <Box width={"100%"} padding={"7% 0%"}>
      <Box>
        <Typography
          variant="h4"
          color="#33E68C"
          fontWeight={800}
          paddingBottom={"1%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#fff"
            fontWeight={800}
            variant={"h4"}
          >
            Our {""}
          </Typography>
          Services
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          width={"100%"}
          flexWrap={"wrap"}
        >
          {list.map((lists, id) => (
            <Box
              key={id}
              width={{ xs: "100%", sm: "30%" }}
              marginTop={{ xs: "10%", sm: "5%" }}
              padding={{ xs: "2%", sm: "1%" }}
              data-aos={"fade-up"}
              sx={{
                "&:hover": {
                  backgroundColor: "#2C2D34",
                  cursor: "pointer",
                },
              }}
            >
              <Box marginRight={{ xs: "85%", sm: "85%" }}>
                <Avatar variant="rounded" sx={{ bgcolor: "#fff" }}>
                  {lists.icon}
                </Avatar>
              </Box>
              <Typography
                variant={"h5"}
                fontWeight={700}
                textAlign={"left"}
                paddingTop={"7%"}
                color={"#fff"}
              >
                {lists.title}
              </Typography>
              <Typography
                variant={"body1"}
                fontWeight={500}
                textAlign={"left"}
                paddingTop={"3%"}
                paddingBottom={"5%"}
                lineHeight={"1.625em"}
                color={"#fff"}
              >
                {lists.description}
              </Typography>
              <Divider color={"#bbb"} paddingTop={"3%"} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ServiceList;
